import styled from 'styled-components'
import React, { useContext, useEffect, useState } from 'react'
import Toggle from 'react-toggle'
import 'react-toggle/style.css'
import { requestTranslation } from '@futures-platform/i18n'
// import { ACTIONS } from '../../store/Actions'
// import { DataContext } from '../../store/GlobalState'

const ToggleSwitcherForHistoryInsideEditor = ({ checked, toggleHandler }) => {
  // const {
  //   state: {},
  //   dispatch,
  // } = useContext(DataContext)

  const handleShowTagsToggle = (event) => {
    // event.preventDefault()
    // event.stopPropagation()

    toggleHandler()
  }

  return (
    <label
      style={{
        margin: 0,
        display: 'flex',
        alignItems: 'center',
      }}>
      <Toggle
        defaultChecked={checked}
        checked={checked}
        icons={false}
        onChange={handleShowTagsToggle}
      />
    </label>
  )
}

export default ToggleSwitcherForHistoryInsideEditor

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 57px !important;
  height: 26px !important;
  margin-bottom: 12px;
  margin-right: 3px;
`
const SliderRound = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  &:before {
    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    left: 1px;
    bottom: 1px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`

const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${SliderRound} {
    background-color: #21aff3;
  }
  &:focus + ${SliderRound} {
    box-shadow: 0 0 1px #2196f3;
  }
  &:checked + ${SliderRound}:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
    border: 1px solid green;
    left: 7px;

    position: absolute;
    content: '';
    height: 24px;
    width: 24px;
    bottom: 1px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`

const TextSwitch = styled.p`
  margin-right: 10%;
`
